import { useEffect } from 'react';

// x-data-spreadsheet@1.1.5, vendored under public/ and served from 'self' instead
// of unpkg.com. unpkg serves arbitrary npm packages by path, so allowlisting the
// bare host in script-src is a known CSP bypass vector (an injected
// <script src="https://unpkg.com/angular..."> defeats the policy). Self-hosting
// also removes a third-party availability/supply-chain dependency. See
// terraform/modules/csp-headers-policy (PROV-4700). Update the file under
// public/vendor/x-data-spreadsheet/ if the pinned version changes.
export const X_SPREADSHEET_SCRIPT_URL = `${process.env.PUBLIC_URL}/vendor/x-data-spreadsheet/xspreadsheet.js`;

export function useScript(url: string) {
  useEffect(() => {
    const script = document.createElement('script');

    script.src = url;
    script.async = true;

    document.body.append(script);

    return () => {
      script.remove();
    };
  }, [url]);
}
